import * as actionTypes from './actionTypes';

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START
  };
};

export const pinxtStart = () => {
  return {
    type: actionTypes.PINXT_START
  };
};

export const pinxtSaga = () => {
 return {
   type: actionTypes.PINXT_TRY
 }
}

export const toggleIsDummy = () => {
  return {
    type: actionTypes.TOGGLE_IS_DUMMY
  }
 }

export const authSuccess = (token) => {
  // sessionStorage.setItem('token', token);
  // sessionStorage.setItem('user', user);
  return {
    type: actionTypes.AUTH_SUCCESS,
    token: token,
  };
};

export const pinxtSuccess = (token) => {
  // sessionStorage.setItem('token', token);
  // sessionStorage.setItem('user', user);
  return {
    type: actionTypes.PINXT_SUCCESS,
    pinxtToken: token,
  };
};

export const authFail = error => {
  return {
    type: actionTypes.AUTH_FAIL,
    error: error
  };
};
export const pinxtFail = error => {
  return {
    type: actionTypes.PINXT_FAIL,
    error: error
  };
};

export const logout = () => {
  return {
    type: actionTypes.AUTH_INITIATE_LOGOUT
  };
};

export const logoutSucceed = () => {
  return {
    type: actionTypes.AUTH_LOGOUT
  };
};

export const checkAuthTimeout = expirationTime => {
  return {
    type: actionTypes.AUTH_CHECK_TIMEOUT,
    expirationTime: expirationTime
  };
};
export const checkPinxtTimeout = expirationTime => {
  return {
    type: actionTypes.PINXT_CHECK_TIMEOUT,
    expirationTime: expirationTime
  };
};

export const auth = (username, password, isSignup) => {
  return {
    type: actionTypes.AUTH_USER,
    username: username,
    password: password,
    isSignup: isSignup
  };
};

export const setAuthRedirectPath = path => {
  return {
    type: actionTypes.SET_AUTH_REDIRECT_PATH,
    path: path
  };
};
export const authUserSaga = ()=> {
  return {
    type: actionTypes.AUTH_USER,
  };
};
export const authTokenSaga = (authCode,winServerUrl)=> {
  return {
    type: actionTypes.AUTH_TOKEN,
    authCode:authCode,
    winServerUrl:winServerUrl
  };
};
export const startAppSaga = (masterAcct, tenantAcct, multi, pspPage, tenantDetails) => {
  // console.log('ACC TOK ACTions')
  return{
    type: actionTypes.START_APP,
    masterAcct:masterAcct,
    tenantAcct:tenantAcct,
    multi:multi,
    pspPage:pspPage,
    tenantDetails:tenantDetails
  }
}

export const authCheckState = (authCode, winServerUrl) => {
  return {
    type: actionTypes.AUTH_CHECK_STATE,
    authCode: authCode,
    winServerUrl: winServerUrl
  };
};

export const pinxtCheckState = () => {
  return {
    type: actionTypes.PINXT_CHECK_STATE
  };
};